import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Rx';

import { IMyOptions, IMyDate } from 'mydatepicker';

import { Campaign } from '../campaign.model';
import { CampaignService } from '../campaign.service';

declare var $: any;

@Component({
 selector: 'wm-campaign-edit',
 template: require('./campaign-edit.component.html')
})
export class CampaignEditComponent implements OnInit, OnChanges {
  @Input() campaign: Campaign;
  @Input() project_id: string;

  @Output() campaignAdd = new EventEmitter();
  @Output() campaignUpdate = new EventEmitter();

  campaignForm: FormGroup;
  submitted: boolean;

  formErrors = {'name': ''};

  validationMessages = {
   'name': {
      required: 'Имя не может быть пустым',
      minlength: 'Имя не может быть короче 3 симвалов',
    }
  };

  campaignDateOptions: IMyOptions = {
    dateFormat: 'dd.mm.yyyy',
    openSelectorOnInputClick: true,
    disableUntil: this.getYesterday()
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private service: CampaignService
  ) { }

  ngOnInit() {
    this.buildForm();
    this.submitted = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.campaign = changes.campaign.currentValue;
    let previous = changes.campaign.previousValue;

    if (!!changes.campaign.currentValue) {
      this.campaignForm.patchValue({
        name: this.campaign.name
      });

      if (!!this.campaign.start_date) {
        this.campaignForm.patchValue({
          start_date: {
            date: this.setDate(this.campaign.start_date)
          }
        });
      }

      if (!!this.campaign.end_date) {
        this.campaignForm.patchValue({
          end_date: {
            date: this.setDate(this.campaign.end_date)
          }
        });
      }
    }
  }

  hideEditForm() {
    $('.edit-form').removeClass('show');

    this.campaignUpdate.emit(undefined);

    this.formErrors = {'name': ''};
    this.buildForm();
  }

  getYesterday(): IMyDate {
    let date = new Date();
    date.setDate(date.getDate() - 1);

    let i_date = <IMyDate> {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };

    return i_date;
  }

  setDate(date_string: string): IMyDate {
    let date = new Date(date_string);

    let i_date = <IMyDate> {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };

    return i_date;
  }

  prepareDate(model: Campaign): Campaign {
    let prepare = model;
    for (let field of Object.keys(model)) {
      if (!!model[field] && !!model[field].jsdate) {
        prepare[field] = model[field].jsdate;
      }
    }
    return prepare;
  }

  onSubmit(model: Campaign, valid: boolean) {
    this.submitted = true;

    if (!valid) {
      this.validateForm();

      return false;
    }

    model = this.prepareDate(model);

    if (!!this.campaign && !!this.campaign.id) {
      this.service.updateCampaign(this.campaign.id, model).subscribe(result => {
        this.campaignUpdate.emit(result['campaign']);
        this.hideEditForm();
      });
    } else {
      this.service.createCampaign(this.project_id, model).subscribe(result => {
        this.campaignAdd.emit(result['campaign']);
        this.hideEditForm();
      });
    }

    return false;
  }

  buildForm() {
    this.campaignForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      start_date: [''],
      end_date: ['']
    });
  }

  validateForm() {
    for (let field of Object.keys(this.formErrors)) {
      this.formErrors[field] = '';
      let input = this.campaignForm.get(field);

      if ((input.invalid && input.dirty) || this.submitted) {
        if (!!input.errors) {
          for (let error of Object.keys(input.errors)) {
            this.formErrors[field] = this.validationMessages[field][error];
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/campaigns/components/campaign-edit.component.ts